/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.602 17.219a8 8 0 1 1 1.06-1.06l3.368 3.367a.75.75 0 0 1-1.06 1.06l-3.368-3.367ZM18 11.056a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgSearch)
export default Memo
